import Vue from 'vue'
import Router from 'vue-router'
const index = r => require.ensure([], () => r(require('@/components/index')), 'index');
const news = r => require.ensure([], () => r(require('@/components/news')), 'news');
const content = r => require.ensure([], () => r(require('@/components/content')), 'content');
const apply = r => require.ensure([], () => r(require('@/components/apply')), 'apply');
const intro = r => require.ensure([], () => r(require('@/components/intro')), 'intro');
const orzChart = r => require.ensure([], () => r(require('@/components/orz-chart')), 'orzChart');
const anthem = r => require.ensure([], () => r(require('@/components/anthem')), 'anthem');
const notice = r => require.ensure([], () => r(require('@/components/notice')), 'notice');
const infos = r => require.ensure([], () => r(require('@/components/infos')), 'infos');
const list = r => require.ensure([], () => r(require('@/components/list')), 'list');
const wish = r => require.ensure([], () => r(require('@/components/wish')), 'wish');
const upload = r => require.ensure([], () => r(require('@/components/upload')), 'upload');
const videos = r => require.ensure([], () => r(require('@/components/videos')), 'videos');

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '世界晋江青年联谊会',
        keepAlive: true
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        title: '协会要闻',
        keepAlive: true
      }
    },
    {
      path: '/content',
      name: 'content',
      component: content,
      meta: {
        title: '详情'
      }
    },
    {
      path: '/apply',
      name: 'apply',
      component: apply,
      meta: {
        title: '入会申请'
      }
    },
    {
      path: '/intro',
      name: 'intro',
      component: intro,
      meta: {
        title: '简介'
      }
    },
    {
      path: '/orzChart',
      name: 'orzChart',
      component: orzChart,
      meta: {
        title: '组织架构'
      }
      
    },
    {
      path: '/anthem',
      name: 'anthem',
      component: anthem,
      meta: {
        title: '会歌'
      }
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice,
      meta: {
        title: '入会申请'
      }
    },
    {
      path: '/infos',
      name: 'infos',
      component: infos,
      meta: {
        title: '会员信息'
      }
    },
    {
      path: '/list',
      name: 'list',
      component: list,
      meta: {
        title: '嘉宾风采'
      }
    },
    {
      path: '/wish',
      name: 'wish',
      component: wish,
      meta: {
        title: '圆梦微心愿'
      }
    },
    {
      path: '/upload',
      name: 'upload',
      component: upload,
      meta: {
        title: '寄语世晋青'
      }
    },
    {
      path: '/videos',
      name: 'videos',
      component: videos,
      meta: {
        title: '花絮视频'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js